/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CacheControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns any OK
   * @throws ApiError
   */
  public vehicleCacheEvict({
    vin,
    puid,
  }: {
    vin: string,
    puid: string,
  }): CancelablePromise<Record<string, Record<string, any>>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/vehicles/cache/evict',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * @returns any OK
   * @throws ApiError
   */
  public vehicleCacheEvictAll(): CancelablePromise<Record<string, Record<string, any>>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/vehicles/cache/evict/all',
    });
  }
  /**
   * @returns any OK
   * @throws ApiError
   */
  public specificationModelCacheEvict(): CancelablePromise<Record<string, Record<string, any>>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/specifications-models/cache/evict',
    });
  }
  /**
   * @returns any OK
   * @throws ApiError
   */
  public modelCacheEvict(): CancelablePromise<Record<string, Record<string, any>>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/models/cache/evict',
    });
  }
}
